import { useFocusEffect } from "expo-router";
import { useCallback, useEffect } from "react";

import type { ItemCacheIdentity } from "@memorang/features/src/qa-search/types";
import type { OriginalQuestionData } from "@memorang/features/src/qa-search/types/question";

type UsePostAnswerAiSyncParams = {
	cacheIdentity: ItemCacheIdentity | null;
	isDesktopWeb: boolean;
	itemId: number;
	originalQuestionData: OriginalQuestionData;
	shouldRenderPostAnswer: boolean;
	updateCacheIdentity: (identity: ItemCacheIdentity | null | undefined) => void;
	updateIsAssistantVisible: (visible: boolean) => void;
	updateIsItemAnswered: (answered: boolean) => void;
	updateItemId: (id: string) => void;
	updateOriginalQuestionData: (data: OriginalQuestionData) => void;
	updateSelectedQuery: (query: string) => void;
	updateUserPrompt: (prompt: string) => void;
	userPrompt: string;
};

export const usePostAnswerAiSync = ({
	cacheIdentity,
	isDesktopWeb,
	itemId,
	originalQuestionData,
	shouldRenderPostAnswer,
	updateCacheIdentity,
	updateIsAssistantVisible,
	updateIsItemAnswered,
	updateItemId,
	updateOriginalQuestionData,
	updateSelectedQuery,
	updateUserPrompt,
	userPrompt,
}: UsePostAnswerAiSyncParams) => {
	useEffect(() => {
		updateItemId(`${itemId}`);
		updateUserPrompt(userPrompt);
		updateCacheIdentity(cacheIdentity);
	}, [
		cacheIdentity,
		itemId,
		userPrompt,
		updateCacheIdentity,
		updateItemId,
		updateUserPrompt,
	]);

	useEffect(() => {
		updateIsItemAnswered(shouldRenderPostAnswer);
	}, [shouldRenderPostAnswer, updateIsItemAnswered]);

	useEffect(() => {
		updateOriginalQuestionData(originalQuestionData);
	}, [originalQuestionData, updateOriginalQuestionData]);

	useFocusEffect(
		useCallback(() => {
			if (!isDesktopWeb) {
				updateIsAssistantVisible(false);
				updateSelectedQuery("");
			}
		}, [updateIsAssistantVisible, updateSelectedQuery, isDesktopWeb]),
	);
};
